module.exports = __webpack_public_path__ + "static/img/start-1.668cd34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/start-1.jpg
// module id = tYOL
// module chunks = 0